import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { UtilsDataService } from "src/app/services/utils-data.service";
import { VendorService } from "src/app/services/vendor.service";

@Component({
  selector: "app-vendor-success-page",
  templateUrl: "./vendor-success-page.component.html",
  styleUrl: "./vendor-success-page.component.scss",
})
export class VendorSuccessPageComponent {
  vendorData: any;
  supportMessage: string;
email:any;
maskedEmail: string;
  constructor(private vendorService: VendorService, private router: Router,
    private utilsDataService: UtilsDataService,
  ) {
    console.log();
    this.email = this.utilsDataService.registredEmail
  }

  ngOnInit(): void {
    this.vendorData = this.vendorService.getRegistrationData();
    console.log('VEndor',this.vendorData)
    if (this.vendorData) {
      this.supportMessage = this.vendorData.supportMessage;
      console.log("Registration Data from service:", this.vendorData);
    }
    this.email = this.utilsDataService.registredEmail
    console.log("email",this.utilsDataService.registredEmail)
    this.maskEmail();  // Call masking function after setting email
  }

  maskEmail() {
  if (!this.email || typeof this.email !== 'string' || !this.email.includes('@')) {
    this.maskedEmail = this.email;
    return;
  }

  const [user, domain] = this.email.split('@');

  if (user.length <= 2) {
    this.maskedEmail = `*${user.slice(-1)}@${domain}`;
  } else {
    const maskedUser = user[0] + '*'.repeat(user.length - 2) + user[user.length - 1];
    this.maskedEmail = `${maskedUser}@${domain}`;
  }
}


  goTo(link: any) {
    this.router.navigate([link]);
  }
}
